/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plus-sign': {
    width: 1,
    height: 1,
    viewBox: '0 0 16 16',
    data: '<g _stroke="currentColor" stroke-width="2.5" _fill="none"><path pid="0" d="M8 1v14M15 8H1"/></g>'
  }
})
